/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const plus = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M18 11.2h-5.2V6h-1.6v5.2H6v1.6h5.2V18h1.6v-5.2H18z" />
	</SVG>
);

export default plus;
